import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { IOrderActivityModel } from '@dss-libs/portal/type/portal-types';
import { AutoHideScrollbarDirective, TooltipIfTruncatedDirective } from '@dss-libs/shared/ui/common-directives';
import { TranslocoDirective } from '@jsverse/transloco';
import { TranslocoDatePipe } from '@jsverse/transloco-locale';
import { activityColorClassMapper, getActivityVariant } from '../../../../mappers/activity-log.mapper';

@Component({
  selector: 'dss-libs-feature-activity-log-card',
  imports: [TranslocoDirective, TranslocoDatePipe, AutoHideScrollbarDirective, MatTooltip, TooltipIfTruncatedDirective],
  templateUrl: './activity-log-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityLogCardComponent {
  readonly activities = input<IOrderActivityModel[] | undefined>();

  protected readonly activityColorClassMapper = activityColorClassMapper;
  protected readonly getActivityVariant = getActivityVariant;
}
